<template>
    <div class="wrap-lg">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px 0">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>申请委托书</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card>
        <div slot="header" class="clearfix" style="text-align: center">
          <div style="width: 1000px;margin: auto">
            <el-steps :space="200"  :active="currStep" :align-center="true" finish-status="success">
              <el-step title="检验产品"></el-step>
              <el-step title="样品信息"></el-step>
              <el-step title="委托审核"></el-step>
              <el-step title="支付提交"></el-step>
              <el-step title="提交完成"></el-step>
            </el-steps>
          </div>
        </div>
        <test-product @next="next" @back="back" v-if="currStep === 0" :entrustId="entrustId"></test-product>
        <sample-info @next="next" @back="back" v-if="currStep === 1" :entrustId="entrustId" ref="sampleInfoPage"></sample-info>
        <payment-info @next="next" @back="back" @nextNum="nextNum" v-if="currStep === 2" :entrustId="entrustId" ref="paymentInfoPage"></payment-info>
        <payment-submit @next="next" @back="back" v-if="currStep === 3" :entrustId="entrustId" :paymentRetInfo="paymentRetInfo"></payment-submit>
        <submit-success @next="next" @back="back" v-if="currStep === 4" :entrustId="entrustId"></submit-success>
        <submit-wait @next="next" @back="back" v-if="currStep === 5" :entrustId="entrustId"></submit-wait>
      </el-card>
    </div>
</template>

<script>
import TestProduct from './sub-page/test-product'
import SampleInfo from './sub-page/sample-info'
import PaymentInfo from './sub-page/payment-info'
import PaymentSubmit from './sub-page/payment-submit'
import SubmitSuccess from './sub-page/submit-success'
import SubmitWait from './sub-page/submit-wait'
export default {
  name: 'index',
  components: { SubmitWait, SubmitSuccess, PaymentSubmit, PaymentInfo, SampleInfo, TestProduct },
  data () {
    return {
      entrustId: '',
      scrollToptimer: '',
      paymentRetInfo: {},
      currStep: 0
    }
  },
  beforeRouteLeave (to, from, next) {
    let msg = '正在离开本页面，本页面内所有未保存数据都会丢失'
    if (this.currStep === 0) {
    }
    if (this.currStep === 1) {
      msg = '正在离开本页面，可以点击下方【提交检验委托书】或【暂存】，在个人中心-委托管理中处理待付款订单找回。'
      if (this.$refs.sampleInfoPage.pause) {
        this.$confirm('暂存的委托单可在个人中心-委托管理中处理待付款订单找回', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          // 正常跳转
          next()
        }).catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1)
        })
        return
      }
    }
    if (this.currStep === 2) {
      msg = '正在离开本页面，资料可在个人中心-委托管理，待付款委托单找回。'
      if (this.$refs.paymentInfoPage.pause) {
        this.$confirm('暂存的委托单可在个人中心-委托管理中处理待付款订单找回', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          // 正常跳转
          next()
        }).catch(() => {
          // 如果取消跳转地址栏会变化，这时保持地址栏不变
          window.history.go(1)
        })
        return
      }
    }
    if (this.currStep === 3) {
      msg = '正在离开本页面，资料可在个人中心-委托管理，待付款委托单找回。'
    }
    if (this.currStep !== 4) {
      this.$confirm(msg, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 正常跳转
        next()
      }).catch(() => {
        // 如果取消跳转地址栏会变化，这时保持地址栏不变
        window.history.go(1)
      })
    } else {
      next()
    }
  },
  mounted () {
    if (this.$route.params.sid) {
      this.entrustId = this.$route.params.sid
    }
    if (this.$route.params.st) {
      this.currStep = this.$route.params.st
    }
    window.addEventListener('mousewheel', this.clearTimer)
  },
  methods: {
    next (entrustId, paymentRetInfo) {
      if (entrustId) {
        this.entrustId = entrustId
      }
      if (paymentRetInfo) {
        this.paymentRetInfo = paymentRetInfo
      }
      this.currStep++
      document.body.scrollTop = 0
      this.backTop()
    },

    nextNum (step, entrustId, paymentRetInfo) {
      if (entrustId) {
        this.entrustId = entrustId
      }
      if (paymentRetInfo) {
        this.paymentRetInfo = paymentRetInfo
      }
      this.currStep = step
      document.body.scrollTop = 0
      this.backTop()
    },
    clearTimer () {
      if (this.scrollToptimer) {
        clearInterval(this.scrollToptimer)
      }
    },
    backTop () {
      var that = this
      that.scrollToptimer = setInterval(function () {
        var top = document.body.scrollTop || document.documentElement.scrollTop
        var speed = top / 5
        document.documentElement.scrollTop -= speed
        if (top === 0) {
          if (that.scrollToptimer) {
            clearInterval(that.scrollToptimer)
          }
        }
      }, 30)
    },
    back () {
      this.currStep--
      this.backTop()
    },
    toPage (path) {
      this.$router.push({
        name: path
      })
    },
    reLoad () {
      this.currStep = 0
    }
  }
}
</script>

<style scoped>

</style>
